import React from 'react';
import {Pressable,StyleSheet, View} from 'react-native';

import theme from '../../style/theme';
import Text from '../ui-controls/Text';

import SlideUpModal from './SlideUpModal';

function PromotionUserSignInModal({
  isVisible,
  onNavigate,
}: {
  isVisible: boolean;
  onNavigate: () => void;
}) {
  return (
    <SlideUpModal isVisible={isVisible}>
      <View style={styles.container}>
        <Text style={{marginTop: 40}}>TO ENTER PROMOTION PLEASE</Text>
        <Pressable style={styles.button} onPress={onNavigate}>
          <Text style={styles.enterText}>
            {'Sign-in Or Create Account'.toUpperCase()}
          </Text>
        </Pressable>
      </View>
    </SlideUpModal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  button: {
    marginTop: 10,
    borderRadius: 4,
    backgroundColor: theme.colour.background.button.primary,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  enterText: {
    fontSize: 16,
    color: 'white',
  },
});

export default PromotionUserSignInModal;
